import { render, staticRenderFns } from "./ConnectModal.vue?vue&type=template&id=e3706428&"
import script from "./ConnectModal.vue?vue&type=script&lang=js&"
export * from "./ConnectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3706428')) {
      api.createRecord('e3706428', component.options)
    } else {
      api.reload('e3706428', component.options)
    }
    module.hot.accept("./ConnectModal.vue?vue&type=template&id=e3706428&", function () {
      api.rerender('e3706428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whatsapp/template/component/ConnectModal.vue"
export default component.exports